import React from 'react';
import {Link} from 'react-router-dom';
import Banner from '../components/constants/banner'
import Facebook from '../images/facebook-large.png';
import Instagram from '../images/instagram-large.png';
import Twitter from '../images/twitter-large.png';
import News from '../images/news.svg';
import Campaigns from '../images/campaigns.svg';
import Events from '../images/events.svg';
import Join from '../images/join.svg';

class Home extends React.Component {
    render(){
        return (
            <div className = "homeContent">
                <section className='banner' title="Banner image">
                    <Banner />
                </section>
                <section title="Main page content">
                    <div className="informationBanner">Christchurch Marine Conservation is not currently active, we thank you for your support and hope that you will continue to support other local groups to help protect the Christchurch seafront areas.</div>
                </section>
            </div>
        )
    }
}

export default Home;